import { mapAttachableToParentOption, mapComponentToParentOption } from '../mapper';
import isComponent from './isComponent';
export function findComponentRecursively(componentsArray, targetId) {
    const directMatch = componentsArray.find((component) => component.id === targetId);
    if (directMatch) {
        return directMatch;
    }
    const foundInChildren = componentsArray
        .filter((component) => component.children && component.children.length > 0)
        .map((component) => findComponentRecursively(component.children, targetId))
        .find((result) => result !== null);
    return foundInChildren || null;
}
export function buildAddComponentLaunchContext({ item, components, componentAttachables, lockedTypeFromUrl }) {
    var _a;
    if (isComponent(item.data)) {
        // Component-row plus locks only the parent. The URL type filter describes
        // the visible parent level, not the child type being created.
        const fullComponent = findComponentRecursively(components, Number(item.id));
        return {
            lockedParent: fullComponent ? mapComponentToParentOption(fullComponent) : null,
            lockedTypeId: null
        };
    }
    const attachableData = item.data;
    const matchedAttachable = componentAttachables.find((attachable) => attachable.attachableId === attachableData.attachableId &&
        attachable.attachableType === attachableData.attachableType);
    const lockedParent = matchedAttachable
        ? mapAttachableToParentOption(matchedAttachable)
        : {
            kind: 'attachable',
            attachableId: attachableData.attachableId,
            attachableType: attachableData.attachableType,
            label: attachableData.displayName || attachableData.name,
            subLabel: (_a = attachableData.humanReadableType) !== null && _a !== void 0 ? _a : undefined
        };
    return { lockedParent, lockedTypeId: lockedTypeFromUrl };
}
